import { detectMobileBrowser } from './detectMobileBrowser';
var isMobile = detectMobileBrowser();
var mainMenu = document.getElementById('main-menu');

if (mainMenu) {
    var mainMenuItems = mainMenu.getElementsByClassName('navbar-menu-item');
    var mainMenuNavBar = document.getElementById('main-menu-navbar');

    for (var i = 0; i < mainMenuItems.length; i++) {
        mainMenuItems[i].querySelector('.navbar-menu-item__link').addEventListener('click', onMenuLinkClick);
        mainMenuItems[i].addEventListener('mouseenter', onMenuEnter);
        mainMenuItems[i].addEventListener('mouseleave', onMenuLeave);
    }

    window.addEventListener('resize', onOpenedSubmenu);
    mainMenu.addEventListener('scroll', onOpenedSubmenu);
}

function onOpenedSubmenu() {
    var openedSubmenu = document.querySelector('.main-menu-submenu.in');

    if (openedSubmenu) {
        hideSubmenu(openedSubmenu);
    }
}

function onMenuLinkClick(e) {
    // on XS, SM - link not clickable.
    if (isMobileSizeXsSm() == true) {
        e.preventDefault();
    }
}

function onMenuEnter() {
    closeActiveSubmenu();

    if (!this.hasAttribute('data-target')) {
        return;
    }

    var menuItemTargetId = getMenuItemTargetId(this);
    var coords = this.getBoundingClientRect();
    var subMenu = document.getElementById(menuItemTargetId);

    if (!subMenu.classList.contains('in')) {
        subMenu.style.height = 'auto';

        subMenu.classList.add('in');

        var mainMenuCords = mainMenuNavBar.getBoundingClientRect();
        var mainMenuPos = mainMenuCords.left + mainMenuCords.width;
        var subMenuPos = coords.left + subMenu.offsetWidth;

        if (subMenuPos > mainMenuPos) {
            subMenu.style.right = '0';
        } else {
            subMenu.style.left = (coords.left - mainMenuCords.left) + 'px';
        }
    }
}

function onMenuLeave(e) {
    if (!this.hasAttribute('data-target')) {
        return;
    }

    var menuItemTargetId = getMenuItemTargetId(this);
    var subMenu = document.getElementById(menuItemTargetId);
    var relatedTarget = e.relatedTarget || e.toElement;
    var relatedTargetId = relatedTarget.id;

    if (isMobile) {
        var relatedTargetNode = relatedTarget.nodeName;

        while (relatedTargetId !== menuItemTargetId && relatedTargetNode !== 'BODY') {
            relatedTarget = relatedTarget.parentNode;
            relatedTargetId = relatedTarget.id;
            relatedTargetNode = relatedTarget.nodeName;
        }

        if (menuItemTargetId === relatedTargetId) {
            return;
        }
    } else if (relatedTarget && ((relatedTargetId === mainMenu.id) || (relatedTargetId === menuItemTargetId))) {
        subMenu.addEventListener('mouseleave', onSubMenuMouseLeave);
        return;
    }

    hideSubmenu(subMenu);
}

function onSubMenuMouseLeave() {
    hideSubmenu(this);

    this.removeEventListener('mouseleave', onSubMenuMouseLeave);
}

function closeActiveSubmenu() {
    var mainMenuSubMenus = document.getElementById('main-menu-submenus');
    var openedSubmenus = mainMenuSubMenus.getElementsByClassName('in');

    for (var i = 0; i < openedSubmenus.length; i++) {
        openedSubmenus[i].classList.remove('in');
    }
}

function getMenuItemTargetId(menuItem) {
    var menuItemTarget = menuItem.getAttribute('data-target');

    return menuItemTarget.substring(1);
}

function hideSubmenu(subMenu) {
    if (subMenu.classList.contains('in')) {
        subMenu.classList.remove('in');
    }

    if (subMenu.classList.contains('collapsing')) {
        subMenu.classList.remove('collapsing');
    }

    subMenu.style.removeProperty('height');
    subMenu.style.removeProperty('left');
    subMenu.style.removeProperty('right');
}

function isMobileSizeXsSm() {
    return window.matchMedia('(max-width: 992px)').matches;
}
